import React from "react";
import { Routes, Route, BrowserRouter } from "react-router-dom";
import AdminRoutes from "./AdminRoutes";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/*" element={<AdminRoutes />} />
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
